// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomEmployerForm from './view'

export default function DataVaxiomEmployerFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomEmployerForm">
      <DataVaxiomEmployerForm {...props}>
        {children}
      </DataVaxiomEmployerForm>
    </Flow>
  )
}
